// Resolve the responsible lawyer's email from the file XML's <lawyer> node.
//
// Priority order matters here. The lawyer node carries several emails that
// belong to DIFFERENT people:
//
// 1. FirmEmail attribute (with isFirmEmailOverWrite="1") — copied from the
//    assigned Responsible Lawyer's own profile by SetOtherLawyerInfo when the
//    lawyer is picked on the file. This is the lawyer of record's email and
//    is the only source that is correct when someone other than the lawyer
//    (e.g. a clerk) is logged in.
// 2. ThirdPartyAcounts/Account[@Party='Email'] — the LOGGED-IN user's
//    third-party email account (their send-as SMTP credentials). Legacy code
//    calls this node "currentUser". Equals the lawyer only when the lawyer
//    is the one logged in.
// 3. SubUserEmail attribute — the logged-in station profile's FirmEmail,
//    stamped by getlawyerprofile.asp. Again the logged-in user, not
//    necessarily the lawyer.
//
// 2 and 3 are kept as fallbacks for firms where the lawyer creates their own
// sessions and no per-lawyer profile email is set.

const findAccountEmail = (node: any): string => {
    if (!node) return '';
    if (node.name === 'Account' && node.attributes?.Party === 'Email') {
        return node.attributes?.Email ?? '';
    }
    for (const child of node.children ?? []) {
        const found = findAccountEmail(child);
        if (found) return found;
    }
    return '';
};

export const resolveLawyerEmail = (lawyerNode: any): string => {
    const attrs = lawyerNode?.attributes ?? {};
    const profileEmail = attrs.isFirmEmailOverWrite === '1' ? (attrs.FirmEmail ?? '') : '';
    return profileEmail || findAccountEmail(lawyerNode) || attrs.SubUserEmail || '';
};
